import React from "react";
import check from "../../icons/icon_check.svg";
import AboutImgTwo from "../../images/about/about-img-two.svg";
const AboutSolution = () => {
  return (
    <section className="problem_solution_section section_space pb-0">
      <div className="container">
        <div
          className="ico_heading_block text-center"
          data-aos="fade-up"
          data-aos-duration="600"
        >
          <div className="row justify-content-center">
            <div className="col-lg-6 text-center">
              {/* <h2 className="heading_text mb-0">What Makes Us Different?</h2> */}
              <h2 className="heading_text mb-0">What Makes TopCoin UK Different?</h2>
              
            </div>
          </div>
        </div>

        <div
          className="ico_problem_solution_table mb-3"
          data-aos="fade-up"
          data-aos-duration="600"
          data-aos-delay="100"
        >
          <div className="column_wrapper align-items-center">
            {/* ICO Problem Section */}
            <div className="column_problem">
              {/* <h3 className="heading_text mb-4">
                <span className="icon">
                  <img src={sIcon1} alt="Icon Man With Question" />
                </span> 
                <span className="text text-dark">For Customers</span>
              </h3> */}
              <ul className="iconlist_block unordered_list_block">
                {[
                  {
                    label:
                      "Not a cryptocurrency.",
                  },
                  {
                    label:
                      // "Not an investment or gambling system.",
                      "Not an investment, savings, or gambling platform.",
                  },
                  {
                    label:
                      // "No risk, just rewards.",
                      "A structured loyalty and promotional rewards programme.",
                  },
                  {
                    // label: "Cash rewards are released by TopCoin UK when loyalty milestones are reached.",
                    label: "Promotional cash rewards may be released when loyalty milestones are achieved, subject to programme rules.",
                  },
                   {
                    // label: "Shops benefit from additional promotional income through customer activity across the network.",
                    label: "Businesses benefit from increased customer engagement and promotional exposure across the network.",
                  },
                    {
                    // label: "Designed for long-term loyalty and smarter local advertising.",
                    label: "Designed to support long-term customer loyalty and smarter local advertising.",
                  },
                  
                ].map((item, index) => (
                  <li key={index}>
                    <span className="iconlist_icon">
                      <img src={check} alt="Icon Check" />
                    </span>
                    <span className="iconlist_label">
                      {item.label}
                      {/* <small className="iconlist_info">{item.info}</small> */}
                    </span>
                  </li>
                ))}
              </ul>
          
            </div>

            {/* ICO Solution Section */}
            <div className="column_solution justify-content-center text-center">
              <div className="row align-items-center justify-content-center">
             
                 <div className="column_problem p-5">
                  <img src={AboutImgTwo} className="img-fluid" alt=""/>
           
            </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8 text-center">
             <p>
                {/* Every time a customer shops at a participating business, both the customer and the shop owner benefit. It’s a system built on fairness, innovation, and real-world value — ideal for businesses that want to stand out and customers who want to receive more rewards from their everyday shopping. */}
                Every time a customer shops at a participating business, both the customer and the shop owner benefit. It’s a loyalty and promotional system built on fairness, innovation, and everyday shopping engagement — designed for businesses that want to stand out and customers who want to receive more promotional rewards from their regular purchases.
              </p>
              <p>
                {/* Whether you’re a business looking to grow, or a customer ready to start collecting rewards, TopCoin UK represents the future of customer loyalty. */}
                Whether you’re a business looking to grow, or a customer ready to start collecting rewards, TopCoin UK is designed to support modern customer loyalty through a structured promotional rewards programme.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSolution;
